import React from 'react';
import _ from 'lodash';

class DealerMake extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.inBlacklist = this.inBlacklist.bind(this);
    this.getPriceData = this.getPriceData.bind(this);
    this.handleCheckboxState = this.handleCheckboxState.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.getModelPriceAdjustment = this.getModelPriceAdjustment.bind(this);
  }

  handleChange(event) {
    // Disable change while updating
    // let parentContainer = document.getElementById("dealerMakes");
    const inputs = document.getElementsByClassName('blacklist');
    this.handleCheckboxState(inputs, 'disable');

    const blacklist = this.props.dealer.modelsBlacklist;
    const id = event.target.getAttribute('data-id');

    // Handle checkbox events
    if (event.target.checked === true) {
      // Checkbox is checked
      // add to blacklist
      blacklist.push(id);
    } else {
      // Checkbox is unchecked
      // Remove from blacklist
      const index = blacklist.indexOf(id);
      if (index > -1) {
        blacklist.splice(index, 1);
      }
    }

    // Either way, we should now have a brand-spankin-new blacklist object. Store this on the dealer object
    // let dealer = this.props.dealer;
    // dealer.modelsBlacklist = blacklist;
    // Update state in parent component
    // Need to create an event object with name and value
    const newObj = {
      target: {
        name: 'modelsBlacklist',
        value: blacklist
      }
    };
    this.props.handleFieldChange(newObj);
    // this.props.updateDealerState(dealer);
    this.handleCheckboxState(inputs, 'enable');
  }

  inBlacklist(modelid) {
    const blacklist = this.props.dealer.modelsBlacklist;

    if (blacklist) {
      const inList = blacklist.indexOf(modelid);
      if (inList > -1) {
        return true;
      }
    }
    return false;
  }

  handleCheckboxState(inputs, newState) {
    if (newState === 'enable') {
      _.forEach(inputs, function (input) {
        input.disabled = false;
      });
    } else {
      _.forEach(inputs, function (input) {
        input.disabled = true;
      });
    }
  }

  handlePriceChange() {
    const modelsPriceAdjustments = [];

    const inputs = document.getElementsByClassName('priceadjustment');

    _.forEach(inputs, function (input) {
      if (input.value !== '' && input.value !== undefined) {
        modelsPriceAdjustments.push({
          modelId: input.dataset.id,
          value: input.value
        });
      }
    });

    const newObj = {
      target: {
        name: 'modelsPriceAdjustments',
        value: modelsPriceAdjustments
      }
    };
    this.props.handleFieldChange(newObj);
  }

  getPriceData(modelId) {
    const modelsPriceAdjustments = this.props.dealer.modelsPriceAdjustments;
    let obj = null;
    _.forEach(modelsPriceAdjustments, function (priceObj) {
      if (priceObj.modelId === modelId) {
        obj = priceObj;
      }
    });

    if (obj) {
      return obj.value;
    }
    return null;
  }

  getModelPriceAdjustment(makeSlug, model, dealerBaseAdjustment) {
    /**************************************************************
     * NOTE: This calculation should mirror the one used frontend *
     **************************************************************/
    const modelsPriceAdjustments = this.props.dealer.modelsPriceAdjustments;
    let modelAdjustment = 0;

    const isVan = model.category && model.category.includes('Varebil');
    const isElectric = model.category && model.category.includes('Elbil');

    let reason = '';

    if (modelsPriceAdjustments) {
      const modelPriceAdjustement = modelsPriceAdjustments.find((m) => m.modelId === model.id);
      if (modelPriceAdjustement) {
        modelAdjustment = parseInt(modelPriceAdjustement.value, 10);
      }
    }

    if (isVan) {
      if (makeSlug === 'mitsubishi') {
        // No VAT on adjustments for mmc van cars
        dealerBaseAdjustment = Math.ceil(dealerBaseAdjustment / 1.25);
        // Note: We do not remove VAT on the modelAdjustments, as this price should already be without VAT
        reason = 'Ingen mva på varebil.';
      }
    } else if (isElectric) {
      // No VAT on electric cars adjustments
      dealerBaseAdjustment = Math.ceil(dealerBaseAdjustment / 1.25);
      // Note: We do not remove VAT on the modelAdjustments, as this price should already be without VAT
      reason = 'Pris eks. mva på elbil. mva blir kalkulert autoamtisk ved pris > 500k';
    }

    const totalAdjustment = parseInt(dealerBaseAdjustment, 10) + parseInt(modelAdjustment, 10);
    return [reason, totalAdjustment];
  }

  render() {
    if (this.props.make) {
      const make = this.props.make;

      // console.log(this.props.dealer);

      let priceadjustment = this.props.dealer.priceadjustment;
      if (priceadjustment === '' || priceadjustment === undefined) {
        priceadjustment = 0;
      }

      return (
        <div className="dealerMake">
          <h3>{make.make.name}</h3>
          <p className="help-block">Fraktjustering pr modell kan være positiv eller negativ. Effektiv fraktjustering regnes ut fra denne og generell fraktjustering, oppgitt over.</p>
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr>
                <th>Føres ikke</th>
                <th>Navn <small>(og kategorier)</small></th>
                <th>Fraktjustering modell</th>
                <th>Effektiv fraktjustering</th>
              </tr>
            </thead>
            <tbody>
              {make.models.map((model, i) => {
                if (model.archived) {
                  return null;
                }

                const [modelAdjustmentReason, modelAdjustment] = this.getModelPriceAdjustment(make.make.slug, model, priceadjustment);

                return (
                  <tr key={i}>
                    <td className="text-center">
                      <input type="checkbox" name="blacklist" className="blacklist" data-id={model.id} onChange={this.handleChange} defaultChecked={this.inBlacklist(model.id)} value=""/>
                    </td>
                    <td>
                      {model.name}
                      <br />
                      <small>{model.category && model.category.join(', ')}</small>
                    </td>
                    <td>
                      <div className="">
                        <div className="input-group">
                          <div className="input-group-addon">NOK</div>
                          <input type="text" name="priceadjustment" className="priceadjustment form-control text-right" data-id={model.id} defaultValue={this.getPriceData(model.id)} onChange={this.handlePriceChange} disabled={this.props.working}/>
                          <div className="input-group-addon">,-</div>
                        </div>
                      </div>
                    </td>
                    <td className="text-right">{modelAdjustment},-<br /><small>{modelAdjustmentReason}</small></td>
                    {/* <td className="text-center">
                      <Link className="btn btn-sm btn-default" to={`modeller/${make.make.id}/modell/${model.id}`} key={model.id}>Se mer / endre</Link>
                    </td>*/}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  }
}

export default DealerMake;
